/* LE BÂNQUET — agregar al carrito desde la rejilla
   El «+» de cada ficha suma sin recargar la página y se convierte en un
   contador, de modo que pedir tres unidades no obliga a entrar al producto.

   La cuenta que se ve en pantalla sube y baja al instante; la petición al
   carrito sale una sola vez, cuando el visitante deja de pulsar. Antes cada
   clic lanzaba su propia petición y bloqueaba los botones mientras tanto,
   así que pedir nueve unidades era imposible de hacer rápido.

   Usa la API de carrito de Shopify; si falla, cae al formulario de siempre. */
(() => {
  /* Varias secciones piden este archivo (la rejilla, los relacionados, la
     ficha…). El navegador lo descarga una vez, pero ejecuta cada etiqueta:
     sin esta guarda se registraban dos oyentes de clic en la ficha de
     producto y cada «+» sumaba de dos en dos. */
  if (window.__lbCarrito) return;
  window.__lbCarrito = true;

  const RUTAS = (window.routes || {});
  const add    = RUTAS.cart_add_url    || '/cart/add';
  const change = RUTAS.cart_change_url || '/cart/change';

  /* Tiempo de gracia entre el último clic y la petición. Suficiente para
     encadenar pulsaciones, corto para que el carrito no se sienta lento. */
  const ESPERA = 420;

  const pedir = (url, cuerpo) =>
    fetch(`${url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(cuerpo),
    }).then((r) => {
      if (!r.ok) throw new Error(r.statusText);
      return r.json();
    });

  /* Shopify no expone un evento propio para esto; se avisa al tema para
     que el contador de la cabecera y el cajón del carrito se refresquen. */
  const avisar = () => {
    document.dispatchEvent(new CustomEvent('lb:carrito-actualizado'));
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((carrito) => {
        document.querySelectorAll('.cart-count-bubble span[aria-hidden]').forEach((n) => {
          n.textContent = carrito.item_count;
        });
        const burbuja = document.querySelector('.cart-count-bubble');
        if (burbuja) burbuja.hidden = carrito.item_count === 0;
      })
      .catch(() => {});
  };

  /* Cuántas unidades quedan. 0 significa «sin techo»: o no se lleva
     inventario, o el producto se puede vender sin existencias. */
  const tope = (ficha) => Number(ficha.dataset.tope || 0);

  /* El precio no se mueve: solo aparece o desaparece el «−», y la cantidad
     se pinta sobre la fotografía. */
  const pintar = (ficha) => {
    const n = Number(ficha.dataset.cantidad || 0);
    const menos = ficha.querySelector('[data-lbp-menos]');
    const mas = ficha.querySelector('[data-lbp-mas]');
    const cifra = ficha.querySelector('[data-lbp-cifra]');
    const aviso = ficha.querySelector('[data-lbp-tope]');
    const techo = tope(ficha);
    const lleno = techo > 0 && n >= techo;

    ficha.classList.toggle('lbp--en-carrito', n > 0);
    ficha.classList.toggle('lbp--tope', lleno);
    if (menos) menos.hidden = n === 0;
    if (cifra) cifra.textContent = n > 0 ? n : '';
    if (mas) {
      mas.disabled = lleno;
      mas.setAttribute('aria-disabled', String(lleno));
    }
    if (aviso) aviso.hidden = !lleno;
  };

  const estado = new WeakMap();

  const leer = (ficha) => {
    let e = estado.get(ficha);
    if (!e) {
      /* «enviado» es lo que el carrito sabe; el data-cantidad es lo que ve
         el visitante. Entre un clic y la petición pueden diferir. */
      e = { enviado: Number(ficha.dataset.cantidad || 0), temporizador: null, enVuelo: false };
      estado.set(ficha, e);
    }
    return e;
  };

  const sincronizar = (ficha) => {
    const e = leer(ficha);
    if (e.enVuelo) return;

    const objetivo = Number(ficha.dataset.cantidad || 0);
    if (objetivo === e.enviado) { ficha.classList.remove('lbp--cargando'); return; }

    const id = ficha.dataset.variante;
    e.enVuelo = true;
    ficha.classList.add('lbp--cargando');

    const peticion = e.enviado === 0
      ? pedir(add, { items: [{ id: Number(id), quantity: objetivo }] })
      : pedir(change, { id: String(id), quantity: objetivo });

    peticion
      .then(() => {
        e.enviado = objetivo;
        avisar();
      })
      .catch(() => {
        /* Se devuelve la cuenta a lo que el carrito tiene de verdad, para no
           mostrar un número que no existe. */
        ficha.dataset.cantidad = String(e.enviado);
        pintar(ficha);
      })
      .finally(() => {
        e.enVuelo = false;
        ficha.classList.remove('lbp--cargando');
        // Si siguieron pulsando mientras iba en camino, se manda el resto.
        if (Number(ficha.dataset.cantidad || 0) !== e.enviado) sincronizar(ficha);
      });
  };

  const fijar = (ficha, cantidad) => {
    const e = leer(ficha);
    const techo = tope(ficha);
    // Más allá del stock la petición fallaría; se corta antes.
    if (techo > 0 && cantidad > techo) {
      ficha.dataset.cantidad = String(techo);
      pintar(ficha);
      return;
    }
    if (cantidad === Number(ficha.dataset.cantidad || 0)) return;

    // Lo que se ve cambia ya; el carrito se entera en un momento.
    ficha.dataset.cantidad = String(cantidad);
    pintar(ficha);

    clearTimeout(e.temporizador);
    e.temporizador = setTimeout(() => sincronizar(ficha), ESPERA);
  };

  document.addEventListener('click', (e) => {
    const ficha = e.target.closest('[data-lbp]');
    if (!ficha) return;
    const n = Number(ficha.dataset.cantidad || 0);

    const mas = e.target.closest('[data-lbp-mas]');
    if (mas && !mas.disabled)                 { e.preventDefault(); fijar(ficha, n + 1); }
    if (e.target.closest('[data-lbp-menos]')) { e.preventDefault(); fijar(ficha, Math.max(0, n - 1)); }
  });

  /* Si se cierra la pestaña con un cambio aún sin mandar, se manda ahora. */
  window.addEventListener('pagehide', () => {
    document.querySelectorAll('[data-lbp]').forEach((ficha) => {
      const e = estado.get(ficha);
      if (!e || e.enVuelo) return;
      const objetivo = Number(ficha.dataset.cantidad || 0);
      if (objetivo === e.enviado) return;
      clearTimeout(e.temporizador);
      const id = ficha.dataset.variante;
      const cuerpo = e.enviado === 0
        ? [add, { items: [{ id: Number(id), quantity: objetivo }] }]
        : [change, { id: String(id), quantity: objetivo }];
      const blob = new Blob([JSON.stringify(cuerpo[1])], { type: 'application/json' });
      if (navigator.sendBeacon) navigator.sendBeacon(`${cuerpo[0]}.js`, blob);
    });
  });

  document.querySelectorAll('[data-lbp]').forEach(pintar);
})();
